import React from 'react';
import dynamic from 'next/dynamic';
import { withRouter } from 'next/router';
import withApollo from '../lib/apollo';
import loading from '../lib/loading';
import redirectToNewsDomain from '../lib/redirectToNewsDomain';

const Trends = dynamic(() => import('../components/Trends'), {
  ssr: true,
  loading,
});

export const TrendsPage = () => (<Trends />);

TrendsPage.getInitialProps = ({
  req, res, query, asPath,
}) => {
  redirectToNewsDomain(asPath)({ req, res, query });
  return {};
};

export default withApollo(withRouter(TrendsPage));
